// Resuelve la configuración por entorno en tiempo de ejecución (navegador) en
// base al hostname desde el cual se está sirviendo el frontend. Reemplaza a
// las viejas variables de build REACT_APP_PROVEEDORES_BACK/REACT_APP_SECRET,
// que ya no pueden diferenciar entornos porque el nuevo pipeline de GitLab
// usa una única imagen para develop y production.
//
// ENCRYPTION_SECRET solo ofusca lo que se guarda en localStorage (ver
// utils/encryptedData.js): al viajar en el bundle JS no es un secreto real,
// cualquiera puede leerlo desde devtools. Mantenerlo distinto por entorno es
// por prolijidad, no por seguridad.
const ENV_BY_HOSTNAME = {
  "proveedores.lbo.com.ar": {
    apiBaseUrl: "https://api.proveedores.lbo.com.ar",
    encryptionSecret: "79a6e25fa987e94dd6e1ab09475a4fd7a224893af74b944",
  },
  "dev.proveedores.lbo.com.ar": {
    apiBaseUrl: "https://dev.api.proveedores.lbo.com.ar",
    encryptionSecret: "7c4e4d2745e6ec8c2a1d6cc37ee7e1d94b4eff40819d2dd",
  },
  localhost: {
    apiBaseUrl: "http://localhost:8000",
    encryptionSecret: "3366ba33b726ba4a0477549618b9632c330eb4c2d582926",
  },
  "127.0.0.1": {
    apiBaseUrl: "http://localhost:8000",
    encryptionSecret: "3366ba33b726ba4a0477549618b9632c330eb4c2d582926",
  },
};

const currentEnv =
  ENV_BY_HOSTNAME[window.location.hostname] ??
  ENV_BY_HOSTNAME["dev.proveedores.lbo.com.ar"];

export const API_BASE_URL = currentEnv.apiBaseUrl;
export const ENCRYPTION_SECRET = currentEnv.encryptionSecret;
